<div class="w-full" [formGroup]="formGroup">
    @if(slot.label){
        <label class="block text-[14px] font-medium text-foreground opacity-80 mb-2">
            {{ slot.label }}
        </label>
    }
    
    <z-select
        [formControlName]="slot.field"
        placeholder=""
        class="w-full"
    >
        @for (option of slot.options; track option.value) {
            <z-select-item [value]="option.value">{{ option.label }}</z-select-item>
        }
    </z-select>
</div>
